import {
  IContactRegistry,
  IPostalAddressRepository,
} from "../../../domain/contact";
import { PostalAddressRepository } from ".";

export class ContactRegistry implements IContactRegistry {
  constructor(private _getToken: () => string) {
  }

  getPostalAddressRepository(): IPostalAddressRepository {
    return new PostalAddressRepository(this._getToken);
  }
}
